/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Title_2Inputs */

const en_about_title_2 = /** @type {(inputs: About_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with understanding`)
};

const lv_about_title_2 = /** @type {(inputs: About_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ar darba`)
};

/**
* | output |
* | --- |
* | "with understanding" |
*
* @param {About_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_title_2 = /** @type {((inputs?: About_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_title_2(inputs)
	return en_about_title_2(inputs)
});